<span>
  <button class="btn-xs bdr-rad-15 mr-2 mb-2 text-lwr" *ngFor="let row of rows;" (click)="toggleSelection(row)" [ngClass]="{'btn-primary': row.selected, 'btn-primary-outline': !row.selected }">{{row.language}}</button></span>